import client from '../httpClient';

const allocationSettingDeleteApi = () => {
  return client.delete('/allocation-setting/');
};

export default allocationSettingDeleteApi;
